








import {Component, Vue} from 'vue-property-decorator';
import {mapState} from 'vuex';

interface ILoginPayload {
  externalId: string;
  password: string;
  tokenExpiresAt: string;
}

@Component({
  computed: mapState(['partner']),
})
export default class Login extends Vue {
  private async created() {
    try {
      const { p, q, t }: { p?: string; q?: string; t?: string} = this.$route.query;
      if (!p || !q || !t) {
        window.location.replace((process.env.VUE_APP_PMP_LOGIN_URL as string));
        return;
      }
      const payload: ILoginPayload = {
        externalId: q,
        password: p,
        tokenExpiresAt: t,
      };
      await this.$store.dispatch('login', payload);
      this.$router.push('/');
    } catch (e) {
      this.$router.push({path: '/error', query: {code: e.code || '000'}});
    }
  }
}
